import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import repairIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getUseStage41_3Totals } from "../../../../../apis/Product/UseStageFlow41Api";

export const REFRESH_USE_STAGE_41_3_TOTALS = "refresh-use-stage-41-3-totals";

const Repair41_3Icon = () => (
  <img src={repairIcon} alt="Repair Icon" width={76} height={76} />
);

const Repair41_3Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalRepairItem, setTotalRepairItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getUseStage41_3Totals({
        productId,
        setTotals: setTotalRepairItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener(REFRESH_USE_STAGE_41_3_TOTALS, handleRefresh);

    return () => {
      window.removeEventListener(REFRESH_USE_STAGE_41_3_TOTALS, handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`repair-41-3-category ${className || ""}`}
      leftBoxProps={{
        icon: <Repair41_3Icon />,
        title: t("REPAIR_41_3") || "Repair",
        description:
          t("REPAIR_41_3_DESC") ||
          "If part of the FU is broken, list the steps required to repair the damage or fault.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_41_3") || "Total for Flow 41.3",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalRepairItem?.impact_totals || null,
        lastUpdated: totalRepairItem?.updated_at
          ? formatDate(totalRepairItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Repair41_3Header;

